<template>
  <div class="wrapper-content w-100">
    <LmComponentLoading v-if="loading" ref="lmComponentLoading" :top="0" />
    <h2 v-if="customListTitle">{{ customListTitle }}</h2>
    <h2 v-else>{{ listTitle }}</h2>
    <LmBreadcrumb v-if="showBreadcrumb"/>
    <div
      v-for="(subTitle, index) in customListSubTitles" :key="index">
      <h4>{{ subTitle }}</h4>
    </div>
    <LmTableCustom v-if="!loading"
      :order = order
      :orderBySetting = orderBySetting
      :searchOnFields = searchOnFields
      :perPageSetting = perPageSetting
      :itemsPerPage = defaultItemsPerPage
      :limitExportFromClient = limitExportFromClient
      :apiCallPath = apiCallPath
      :highlight = highlight
      :actions = actions
      :showFilterTime = showFilterTime
      :showGoBackButton = showGoBackButton
      :showPDFButton = showPDFButton
      :showCSVButton = showCSVButton
      :hideSearchSection = hideSearchSection
      :downloadCsvFileName = downloadCsvFileName
      :lmListActions = lmListActions
      :createSegment = createSegment
      :showLmDropdownTableCustom= showLmDropdownTableCustom
      />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import LmTableCustom from '@/components/LmTableCustom'
import LmButton from '@/components/form/elements/LmButton'

export default {
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes'
    }
  },
  methods: {
    ...mapActions('settings', ['getListSettings'])
  },
  computed: {
    ...mapState('settings', [
      'listTitle',
      'order',
      'orderBySetting',
      'searchOnFields',
      'perPageSetting',
      'defaultItemsPerPage',
      'limitExportFromClient',
      'loading',
      'highlight',
      'apiCallPath',
      'actions',
      'showFilterTime',
      'showGoBackButton',
      'showPDFButton',
      'showCSVButton',
      'downloadCsvFileName',
      'lmListActions',
      'hideSearchSection',
      'hideBreadcrumb',
      'createSegment',
      'showLmDropdownTableCustom'
    ]),
    ...mapState('commons', ['customListTitle', 'customListSubTitles']),
    getListEndpointUri () {
      try {
        if (this.listEndpointUri.indexOf(':id') >= 0) {
          return `${this.listEndpointUri.replace('/:id/', '')}/${this.$route.params.id}`
        } else {
          return this.listEndpointUri
        }
      } catch (error) {
        console.log(error)
        return this.listEndpointUri
      }
    }
  },
  components: {
    LmTableCustom,
    LmButton
  },
  props: ['listEndpointUri'],
  watch: {
    listEndpointUri () {
      this.getListSettings(this.getListEndpointUri)
    }
  },
  created () {
    this.getListSettings(this.getListEndpointUri)
  }
}
</script>

<style lang="sass" scoped>
  h4, h5
    margin-bottom: 30px !important
  table
    margin: 16px
</style>
